import { render } from "./ImageCapture.vue?vue&type=template&id=22f9d95c&scoped=true"
import script from "./ImageCapture.vue?vue&type=script&lang=js"
export * from "./ImageCapture.vue?vue&type=script&lang=js"

import "./ImageCapture.vue?vue&type=style&index=0&id=22f9d95c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f9d95c"]])

export default __exports__